import React from 'react';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import DataDefinedDropdown from './DataDefinedDropdown';

const SearchByDetails = ({
    detailsPanelDropdownOptions,
    languageString,
    fieldValues,
    onDetailsPanelFieldChange,
    isMainCountrySet,
    isStartDateSet,
    onRatesButton
}) => {
    return (
        <fieldset>
            <div className="clear"></div>
            <s-box name="form-panel">
              {
                detailsPanelDropdownOptions ? (
                  <div>
                    <s-row>
                      <s-col span="6">
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'flow'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_flow_label'/>}
                          isSelected={fieldValues.flow}
                          value={fieldValues.flow}
                          definition={detailsPanelDropdownOptions.flow}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'documentType'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_documentType_label'/>}
                          value={fieldValues.documentType}
                          definition={detailsPanelDropdownOptions.documentType}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'transactionType'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_transactionType_label'/>}
                          value={fieldValues.transactionType}
                          definition={detailsPanelDropdownOptions.transactionType}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <div className="vat-rates">
                          <DataDefinedDropdown
                            placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                            name={'vatRateType'}
                            label={<LanguageStringResolver string='vatCodeSearch_Details_vatRate_label'/>}
                            value={fieldValues.vatRateType}
                            definition={detailsPanelDropdownOptions.vatRateType}
                            onFieldChange={onDetailsPanelFieldChange}
                          />
                            <a
                              data-testid='rates-button'
                              disabled={isMainCountrySet && isStartDateSet ? false : true}
                              className={'float-left button ml10 ' + (isMainCountrySet && isStartDateSet ? '' : 'disabled')}
                              onClick={() => onRatesButton(fieldValues.mainCountry, fieldValues.startDate)}>
                                <LanguageStringResolver string='vatCodeSearch_Details_vatRate_viewRates'/>
                            </a>
                        </div>
                      </s-col>
                      {/* Second column in the panel*/}
                      <s-col span="6">
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'goodsType'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_goodsType_label'/>}
                          value={fieldValues.goodsType}
                          definition={detailsPanelDropdownOptions.goodsType}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'supplierType'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_supplier_label'/>}
                          value={fieldValues.supplierType}
                          definition={detailsPanelDropdownOptions.supplierType}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'taxDueType'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_taxDue_label'/>}
                          value={fieldValues.taxDueType}
                          definition={detailsPanelDropdownOptions.taxDueType}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                        <DataDefinedDropdown
                          placeholder={LANGUAGE_CONTROLLER.format(languageString, "vatCodeSearch_dropdown_placeholder")}
                          name={'country'}
                          label={<LanguageStringResolver string='vatCodeSearch_Details_country_label'/>}
                          value={fieldValues.country}
                          definition={detailsPanelDropdownOptions.countries}
                          isSimpleArray={true}
                          onFieldChange={onDetailsPanelFieldChange}
                        />
                      </s-col>
                    </s-row>
                  </div>
                ) : (<div></div>)
              }
            </s-box>
          </fieldset>
    );
};

export default SearchByDetails;
